import { css } from 'aphrodite';
import * as React from 'react';
import { type CategoryVolumeRow, formatCount } from './reportsPresentation';
import { reportsStyles as rs } from './styles/reportsStyles';

interface CategoryVolumeCardProps {
	rows: CategoryVolumeRow[];
	isLoading?: boolean;
}

export const CategoryVolumeCard: React.FC<CategoryVolumeCardProps> = ({ rows, isLoading }) => (
	<section className={css(rs.card)}>
		<div className={css(rs.cardHeader)}>
			<div>
				<h2 className={css(rs.cardTitle)}>Conversations by category</h2>
				<div className={css(rs.cardSubtitle)}>Created in this period</div>
			</div>
		</div>
		{isLoading ? (
			<div className={css(rs.chartLoading)}>Loading…</div>
		) : rows.length === 0 ? (
			<div className={css(rs.chartEmpty)}>No conversations in this period.</div>
		) : (
			<ul className={css(rs.barList)}>
				{rows.map(row => (
					<li key={row.key} className={css(rs.barRow)}>
						<span className={css(rs.barRowLabel)}>
							<span className={css(rs.categoryDot)} style={{ backgroundColor: row.color }} />
							{row.name}
						</span>
						<div className={css(rs.barTrack)}>
							<div className={css(rs.barFill)} style={{ width: `${row.widthPercent}%`, backgroundColor: row.color }} />
						</div>
						<span className={css(rs.barRowValue)}>{formatCount(row.count)}</span>
					</li>
				))}
			</ul>
		)}
	</section>
);
